export const post = (opt) => {
    opt.type = 'POST';
    return request(opt);
};
